{
  "en": "Inglese",
  "de": "Tedesco",
  "fr": "Francese",
  "es": "Spagnolo",
  "cs": "Ceco",
  "da": "Danese",
  "et": "Estone",
  "fi": "Finlandese",
  "hr": "Croato",
  "hu": "Ungherese",
  "it": "Italiano",
  "lt": "Lituano",
  "lv": "Lettone",
  "nl": "Olandese",
  "nb": "Norvegese Bokmål",
  "pl": "Polacco",
  "pt": "Portoghese",
  "ro": "Rumeno",
  "sk": "Slovacco",
  "sl": "Sloveno",
  "sq": "Albanese",
  "sv": "Svedese"
}
